// src/hooks/useCustomButtons.js
import { Button, styled } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { useSelector } from "react-redux";


export const useCustomButtons = () => {
  const theme = useSelector((state) => state.theme.theme);

  const LoadingColorButton = styled(LoadingButton)(() => ({
    color: "#FFFFFF",
    backgroundColor: "#84C14B",
    border: "1px solid #CCC",
    borderRadius: "8px",
    paddingLeft: "15px",
    paddingRight: "15px",
    width: "123px",
    height: "35px",
    "&:hover": {
      background: "#808080",
      color: "white",
    },
  }));

  const ColorButton = styled(Button)(() => ({
     color: "#000000",
     backgroundColor: "#fff",
     border: "1px solid #000",
     borderRadius: "8px",
     paddingLeft: "15px",
     paddingRight: "15px",
     width: "140px",
     height: "35px",
     "&:hover": {
         background: "#808080",
         color: "white",
     },
  }));

  const ColorButton1 = styled(Button)(() => ({
    color: "#FFF",
    backgroundColor: "#84C14B",
    fontFamily: "Poppins",
    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.15)",
    fontSize: "12px",
    borderRadius: "8px",
    paddingLeft: "15px",
    paddingRight: "15px",
    width: "130px",
    height: "35px",
    "&:hover": {
      background: "#808080",
      color: "white",
    },
  }));

  const ColorButton2 = styled(Button)(({width="8rem"}) => ({
    color: "#FFFFFF",
    background: theme === "dark" ? "var(--theme-background-content-color)" : "var(--button-color)",
    border: "1px solid #707070",
    borderRadius: "8px",
    paddingLeft: "15px",
    paddingRight: "15px",
    fontSize: "0.8rem",
    width: width,
    height: "35px",
    "&:hover": {
      background: theme === "dark" ? "var(--theme-text-color)" : "var(--button-hover-color)",
      color: theme === "dark" ? "var(--theme-background-content-color)" : "white",
    },
    "@media (max-width: 568px)": {
      width: "100%",
      border: "1px solid #CCC",
      borderRadius: "14px",
      paddingLeft: "18px",
      paddingRight: "18px",
      width: "100%",
      height: "38px",
    },
  }));

  const ColorButton3 = styled(Button)(() => ({
    color: "#FFF",
    backgroundColor: "#84C14B",
    fontFamily: "Poppins",
    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.15)",
    fontSize: "12px",
    borderRadius: "8px",
    paddingLeft: "15px",
    paddingRight: "15px",
    width: "165px",
    height: "35px",
    "&:hover": {
      background: "#808080",
      color: "white",
    },
  }));

  const DeleteButton = styled(Button)(() => ({
    color: "#ED3237",
    fontFamily: "Inter",
    fontSize: "12px",
    fontWeight: "600",
  }));

  const PreviewButton = styled(Button)(() => ({
    color: "black",
    fontFamily: "Inter",
    fontSize: "12px",
    fontWeight: "600",
  }));

  const UploadButton = styled(Button)(() => ({
    color: "#72C631",
    fontFamily: "Poppins",
    fontSize: "12px",
    borderRadius: "8px",
    paddingLeft: "15px",
    paddingRight: "15px",
    border: "1px solid #72C631",
    fontWeight: "400",
    width: "100%",
    height: "35px",
    "&:hover": {
      background: "#72C631",
      color: "white",
    },
    "&.Mui-disabled": {
      backgroundColor: "#BDBDBD",
      color: "white",
      border: "none",
    },
  }));

  const ColorButtonOTP = styled(Button)(() => ({
    color: "#72C631",
    backgroundColor: "#FFFFFF",
    border: "1.5px solid #72C631",
    fontSize: "10px",
    fontWeight: "600",
    borderRadius: "8px",
    paddingLeft: "15px",
    paddingRight: "15px",
    paddingTop: "10px",
    marginLeft: "10px",
    width: "100px",
    height: "33px",
    "&:hover": {
      background: "#72C631",
      color: "white",
    },
  }));

  const ColorButtonVerify = styled(Button)(() => ({
    color: "#72C631",
    backgroundColor: "#FFFFFF",
    border: "1.5px solid #72C631",
    fontSize: "12px",
    fontWeight: "600",
    borderRadius: "6px",
    paddingLeft: "15px",
    paddingRight: "15px",
    width: "90px",
    height: "35px",
    "&:hover": {
      background: "#72C631",
      color: "white",
    },
    "&.Mui-disabled": {
      backgroundColor: "#BDBDBD",
      color: "white",
      border: "none",
    },
  }));

  const ColorButtonSearch = styled(Button)(() => ({
    color: "#FFF",
    backgroundColor: "#158CED",
    fontFamily: "Poppins",
    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.15)",
    fontSize: "12px",
    borderRadius: "8px",
    width: "30px",
    height: "35px",
    "&:hover": {
      background: "#808080",
      color: "white",
    },
  }));

  return {
    LoadingColorButton,
    ColorButton,
    ColorButton1,
    ColorButton2,
    ColorButton3,
    DeleteButton,
    PreviewButton,
    UploadButton,
    ColorButtonOTP,
    ColorButtonVerify,
    ColorButtonSearch,
  };
};
